document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('[id^="Slider-"]');

  sliders.forEach(slider => {
    const section = slider.closest('slideshow-component');
    if (!section) return;

    const nextBtn = section.querySelector('.slider-button--next');
    const prevBtn = section.querySelector('.slider-button--prev');

    let startX = 0;
    let endX = 0;
    let isDragging = false;
    const threshold = 70;

    function getCurrentSlideIndex(slides, slider) {
      let closestIndex = 0;
      let closestDistance = Infinity;

      slides.forEach((slide, i) => {
        const rect = slide.getBoundingClientRect();
        const sliderRect = slider.getBoundingClientRect();
        const distance = Math.abs(rect.left - sliderRect.left);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = i;
        }
      });

      return closestIndex;
    }

    function handleGesture() {
      const diff = startX - endX;
      if (Math.abs(diff) < threshold) return;

      const slides = slider.querySelectorAll('.slider__slide');
      if (!slides.length) return;

      const currentIndex = getCurrentSlideIndex(slides, slider);
      const lastIndex = slides.length - 1;

      // Swipe LEFT → NEXT
      if (diff > 0) {
        if (currentIndex >= lastIndex) {
          // Loop to first slide
          slider.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          nextBtn?.click();
        }
      }

      // Swipe RIGHT → PREV
      else {
        if (currentIndex <= 0) {
          // Loop to last slide
          slider.scrollTo({ left: slider.scrollWidth, behavior: 'smooth' });
        } else {
          prevBtn?.click();
        }
      }
    }

    /* ===== TOUCH (Mobile) ===== */
    slider.addEventListener('touchstart', e => {
      startX = e.touches[0].clientX;
    }, { passive: true });

    slider.addEventListener('touchend', e => {
      endX = e.changedTouches[0].clientX;
      handleGesture();
    }, { passive: true });

    /* ===== MOUSE DRAG (Desktop) ===== */
    slider.addEventListener('mousedown', e => {
      isDragging = true;
      startX = e.clientX;
      slider.classList.add('is-dragging');
    });

    slider.addEventListener('mouseup', e => {
      if (!isDragging) return;
      isDragging = false;
      endX = e.clientX;
      slider.classList.remove('is-dragging');
      handleGesture();
    });

    slider.addEventListener('mouseleave', () => {
      isDragging = false;
      slider.classList.remove('is-dragging');
    });
  });
});


// arrow slider
document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('[id^="Slider-"]');

  sliders.forEach(slider => {
    const section = slider.closest('slideshow-component');
    if (!section) return;

    const nextManual = section.querySelector('.manual-arrow--next');
    const prevManual = section.querySelector('.manual-arrow--prev');
    const slides = slider.querySelectorAll('.slider__slide');
    if (!slides.length || !nextManual || !prevManual) return;

    let currentIndex = 0;

    function goToSlide(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      currentIndex = index;

      const slideLeft = slides[currentIndex].offsetLeft;
      slider.scrollTo({ left: slideLeft, behavior: 'smooth' });
    }

    nextManual.addEventListener('click', () => {
      goToSlide(currentIndex + 1);
    });

    prevManual.addEventListener('click', () => {
      goToSlide(currentIndex - 1);
    });
  });
});
